import { useCallback, useEffect, useRef, useState } from "react";
import { IGiveawayAuto } from "../../../../interfaces";
import { useNavigate } from "react-router-dom";
import { DateFns } from "../../../../utils/dateFns";

interface IProps {
    giveawayAuto?: IGiveawayAuto,
    createdGiveaway?: IGiveawayAuto,
}

export default function useGiveawayForm({ giveawayAuto, createdGiveaway }: IProps) {
    const [currentStep, setCurrentStep] = useState(0);
    const [awardsListLength, setAwardsListLength] = useState<number | undefined>();

    const navigate = useNavigate();
    const refIsEditing = useRef<boolean>(Boolean(giveawayAuto));

    const giveawayExistsAndIsInvalid = !!giveawayAuto && !giveawayAuto.is_valid;
    const isInvalid = awardsListLength === undefined ? giveawayExistsAndIsInvalid : awardsListLength === 0 ? true : false;

    const canEdit = Boolean(giveawayAuto?.date && !DateFns.dateIsAfter(DateFns.dateStringToDateTime(new Date().toISOString()), DateFns.dateStringToDateTime(new Date(giveawayAuto.date).toISOString())));

    const handleClickGiveawayStep = useCallback(() => {
        setCurrentStep(0);
    }, []);

    const handleClickAwardsStep = useCallback(() => {
        setCurrentStep(1);
    }, []);

    const handleClickGiveawayStepWhenCreating = useCallback((createdGiveawayId: number) => {
        if (!createdGiveawayId) {
            return;
        }

        navigate(`/sorteios/auto/editar/${createdGiveawayId}`)
    }, [navigate]);

    const handleSubmitGiveawayDataStepFinished = useCallback(() => {
        if (!giveawayAuto && !createdGiveaway) {
            return;
        }

        setCurrentStep(1);
    }, [giveawayAuto, createdGiveaway]);

    const handleAwardsListLengthChange = useCallback((listLength: number) => {
        setAwardsListLength(listLength);
    }, []);

    useEffect(() => {
        if (!createdGiveaway) {
            return;
        }

        setCurrentStep(1);
    }, [createdGiveaway]);

    return {
        currentStep,
        handleClickGiveawayStep,
        handleClickGiveawayStepWhenCreating,
        handleClickAwardsStep,
        handleSubmitGiveawayDataStepFinished,
        handleAwardsListLengthChange,
        isInvalid,
        refIsEditing,
        canEdit,
    }
}
